import * as React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import { Container, config, Col, Row, Hidden } from 'react-awesome-styled-grid'
import { applyPromoCode, clearPromoCode } from '../actions/subscriptionActions'
import {
  GlobalStyle,
  colors,
  DipseaContentfulAssets,
  QueensH2,
  P
} from '@components/shared'
import { FadeInImage } from '@components/shared/FadeInImage'
import HtmlHead from '@components/HtmlHead'
import SimpleNav from '@components/SimpleNav'
import ConversionPaywallModal from '@components/subscribe/ConversionPaywallModal'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../reducers/appstate'
import {
  togglePromoModal,
  setHeaderCopyForAuthAndSubscribeModals
} from '../actions/promoActions'
import { dismissIntercom } from '@services/intercom'
import { TopBanner } from '@components/shared/TopBanner'
import { openSubscribe } from '../actions/navigationActions'
import { isServer } from '../env'
import { ANNUAL_PRICE_STRING } from '../helpers/subscriptionHelpers'

type PropsType = {
  isServer: boolean,
  router: {
    query: {
      promo?: string
    }
  },
  isIntercomVisible: boolean,
  userEnteredPromo: string,
  welcomeBannerText: string,
  bannerArray: [string, string, string],
  headerArray: [string, string],
  ctaText: string,
  paywallHeader: string,
  paywallDescription: string,
  paywallFinePrint: string,
  promoConfirmationHeaderText?: string
}

type DispatchPropsType = {
  applyPromoCode: (userEnteredPromo: string, isGift: boolean) => void,
  toggleModal: () => void,
  setHeaderCopy: (
    textAuthHeader: string | null,
    textAuthSubheader: string,
    textSubscriptionConfirmationHeader: string | null,
    textSubscriptionConfirmationSubheader: string
  ) => void,
  clearPromo: () => void,
  openSubscribe: () => void
}

type StateType = {
  isLoading: boolean,
  featurePodcastPromoFlow: boolean
}

class Promo extends React.Component<PropsType & DispatchPropsType, StateType> {
  constructor (props: PropsType & DispatchPropsType) {
    super(props)
    this.state = {
      isLoading: true,
      featurePodcastPromoFlow: false
    }
  }

  componentDidUpdate (prevProps: PropsType): void {
    if (prevProps.isIntercomVisible !== this.props.isIntercomVisible) {
      if (this.props.isIntercomVisible) {
        dismissIntercom()
      }
    }
  }

  componentDidMount (): void {
    return this.handleOpenSubscribe()

    // this.setState({ featurePodcastPromoFlow: Math.random() < 0.5 }, (): void => {
    //   this.handleRedirectOrSetPromo()
    // })
  }

  // handleRedirectOrSetPromo = (): void => {
  //   try {
  //     if (window.localStorage['dipsea-promo']) {
  //       // dipsea-promo is on local storage, user has been to this page before.
  //       if (window.localStorage['dipsea-promo'] === 'yes') {
  //         // is part of the promo flow test
  //         return this.handleShowPromoPage()
  //       } else if (window.localStorage['dipsea-promo'] === 'no') {
  //         // should go to subscribe flow.
  //         return this.handleOpenSubscribe()
  //       }
  //     }

  //     // save 'dipsea-promo' to local storage
  //     window.localStorage.setItem(
  //       'dipsea-promo',
  //       `${this.state.featurePodcastPromoFlow ? 'yes' : 'no'}`
  //     )
  //   } catch (e) {
  //     console.log('Local Storage Failed', e)
  //   }

  //   if (this.state.featurePodcastPromoFlow) {
  //     return this.handleShowPromoPage()
  //   } else {
  //     return this.handleOpenSubscribe()
  //   }
  // }

  handleOpenSubscribe = (): void => {
    // user is not part of featurePodcastPromoFlow, redirect to subscribe with utms
    if (!isServer) {
      this.props.openSubscribe()
    }
  }

  handleShowPromoPage = (): void => {
    // user is part of featurePodcastPromoFlow, show promo page and apply promo code
    this.setState({ isLoading: false })

    let urlPromo
    const { promo } = this.props.router.query

    if (!isServer && !promo) {
      const params = new URLSearchParams(window?.location?.search)
      if (params.has('promo')) {
        urlPromo = params.get('promo')
      }
    } else if (promo) {
      urlPromo = promo
    }

    if (urlPromo) {
      this.props.applyPromoCode(urlPromo, false)
    }
  }

  componentWillUnmount (): void {
    this.props.clearPromo()
  }

  render (): React.ReactNode {
    let bannerText = ''

    if (this.props.bannerArray) {
      this.props.bannerArray.forEach((text: string, index: number): void => {
        const string = text.trim()
        if (index === 1) {
          bannerText = bannerText + `<span>${string}</span> `
        } else {
          bannerText = bannerText + string + ' '
        }
      })
    }

    const headerTextWhite = this.props.headerArray[0].trim()
    const headerTextOrange = this.props.headerArray[1].trim()

    const description = 'Explore hundreds of sexy audio stories for hotter "me-time."\nCancel anytime.'
    const paywallCtaText = this.props.ctaText

    if (this.props.welcomeBannerText) {
      bannerText = `${this.props.welcomeBannerText.trim()} ` + bannerText
    }

    const openPaywall = (): void => {
      this.props.toggleModal()

      const textAuthSubheader = 'Explore hundreds of audio stories, bingeable books, wellness sessions, and sleep scenes.'
      const textSubscriptionConfirmationHeader = this.props.promoConfirmationHeaderText || null
      const textSubscriptionConfirmationSubheader = 'Download the app to explore hundreds of audio stories, bingeable books, wellness sessions, and sleep scenes.'

      this.props.setHeaderCopy(
        null,
        textAuthSubheader,
        textSubscriptionConfirmationHeader,
        textSubscriptionConfirmationSubheader
      )
    }

    if (this.state.isLoading) {
      return null
    }

    return (
      <>
        <GlobalStyle backgroundColor={colors.midnightBlue} />
        <HtmlHead
          title={`Dipsea | ${headerTextWhite} ${headerTextOrange}`}
          image={'/images/share-image-dusk.jpg'}
        />
        <SimpleNav
          backgroundColor={colors.midnightBlue95}
          buttonOrder={['sign-out']}
        />

        <ConversionPaywallModal
          subtype='annual'
          defaultSignIn
          subscriptionOfferCta='Pay with card'
          subscriptionOfferTitle={this.props.paywallHeader}
          subscriptionOfferSubtitle={this.props.paywallDescription}
          subscriptionOfferSubtext={this.props.paywallFinePrint}
          isFullScreen
          existingPromoCode={this.props.userEnteredPromo}
          bannerText={bannerText}
          isSocialPayButtonsFirst
        />

        <Section>
          <BackgroundImageContainer>
            <Hidden xs={false} sm={false} md={true} lg={true} xl={true}>
              <FadeInImage
                objectFit='cover'
                layout='fill'
                fadeInTime={0.3}
                src={DipseaContentfulAssets.trope_quiz_intro_mobile}
                aria-hidden='true'
              />
            </Hidden>
            <Hidden xs={true} sm={true} md={false} lg={false} xl={false}>
              <FadeInImage
                objectFit='cover'
                layout='fill'
                fadeInTime={0.3}
                src={DipseaContentfulAssets.trope_quiz_intro_desktop}
                aria-hidden='true'
              />
            </Hidden>
          </BackgroundImageContainer>

          <MainContent>
            <GradientContainer>
              <Container>
                <Row align='center'>
                  <Col
                    xs='4'
                    sm='6'
                    md='6'
                    lg='8'
                    xl='6'
                    offset={{ sm: 1, md: 1, lg: 0, xl: 2 }}
                    align={{ sm: 'center', lg: 'flex-start' }}
                  >
                    <HeaderText>
                      {headerTextWhite}
                      <br />
                      <span className='promo'>{headerTextOrange}</span>
                    </HeaderText>
                    <DescriptionText>{description}</DescriptionText>
                    <PaywallButton onClick={openPaywall}>
                      {paywallCtaText}
                    </PaywallButton>
                  </Col>
                </Row>
              </Container>
            </GradientContainer>
          </MainContent>
        </Section>

        {bannerText.length && <TopBanner bannerText={bannerText} />}
      </>
    )
  }
}

const mapStateToProps = (state: AppStateType, _ownProps: PropsType): { isServer: any, isIntercomVisible: any, userEnteredPromo: any, welcomeBannerText: any, bannerArray: any, headerArray: any, ctaText: any, paywallHeader: any, paywallDescription: any, paywallFinePrint: any, promoConfirmationHeaderText: any } => {
  return {
    isServer,
    isIntercomVisible: typeof window !== 'undefined' && window.Intercom,
    userEnteredPromo:
      state.subscriptionPromo?.userEnteredPromo || 'oneweekfreetrial', // needs to exist in promo.helpers
    welcomeBannerText: state.subscriptionPromo?.welcomeBannerText || undefined,
    bannerArray: state.subscriptionText?.promoBannerText || [
      'Get a',
      '7 Day Free Trial',
      'to Dipsea.'
    ],
    headerArray: state.subscriptionText?.promoHeaderText || [
      'Get Dipsea for',
      '7 Days Free'
    ],
    ctaText: state.subscriptionText?.promoCtaText || 'Get 7 Days Free',
    paywallHeader:
      state.subscriptionText?.promoPaywallHeaderText || 'Get 7 Days Free',
    paywallDescription:
      state.subscriptionText?.promoPaywallDescriptionText ||
      `Annual subscription of ${ANNUAL_PRICE_STRING} USD billed at trial end.`,
    paywallFinePrint: state.subscriptionText?.subscribeText || '',
    promoConfirmationHeaderText:
      state.subscriptionText?.promoConfirmationHeaderText
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchPropsType => {
  return {
    applyPromoCode: (promoCode: string): void =>
      dispatch(applyPromoCode(promoCode, false)),
    clearPromo: (): void => dispatch(clearPromoCode()),
    toggleModal: (): void => dispatch(togglePromoModal()),
    openSubscribe: (): void => dispatch(openSubscribe()),
    setHeaderCopy: (
      textAuthHeader: string | null,
      textAuthSubheader: string,
      textSubscriptionConfirmationHeader: string | null,
      textSubscriptionConfirmationSubheader: string
    ): void => {
      dispatch(
        setHeaderCopyForAuthAndSubscribeModals(
          null,
          textAuthSubheader,
          textSubscriptionConfirmationHeader,
          textSubscriptionConfirmationSubheader
        )
      )
    }
  } as DispatchPropsType
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Promo) as any) as any

const Section = styled.section<any>`
  margin-top: -60px;
  ${(props: any): any => config(props).media.md`
    margin-top: -75px;
  `}

  height: 100%;
  position: relative;
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -ms-backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  width: 100%;
`
const BackgroundImageContainer = styled.div<any>`
  display: flex;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`
export const MainContent = styled.div<any>`
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  display: flex;
  height: 100%;
  padding: 120px 0 0;
  position: relative;
  z-index: 0;
  ${(props: any): any => config(props).media.md`
    padding: 180px 0 0;
  `}
`
export const GradientContainer = styled.div<any>`
  align-items: flex-end;
  background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 54.19%, #26122F 71.56%);
  display: flex;
  overflow: hidden;
  padding: 0 0 48px;
  width: 100%;
  ${(props: any): any => config(props).media.sm`
    align-items: flex-end;
    padding: 0 0 80px;
  `}
  ${(props: any): any => config(props).media.md`
    align-items: center;
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 41.11%, #26122F 54.26%);
    padding: 0 0 40px;
  `}
  ${(props: any): any => config(props).media.lg`
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 47.56%, #26122F 71.56%);
  `}
  ${(props: any): any => config(props).media.xl`
    background: linear-gradient(180deg, rgba(38, 18, 47, 0) 0%, rgba(38, 18, 47, 0.45) 58.59%, #26122F 81.64%);
  `}
`
export const HeaderText = styled.h1<any>`
  ${QueensH2};
  font-family: 'Queens Condensed Light';
  line-height: 120%;
  margin-bottom: 1.25rem;
  text-align: center;
  span.promo {
    color: ${colors.tintOrange};
  }
  ${(props: any): any => config(props).media.sm`
    font-size: 60px;
    line-height: 110%;
  `}
  ${(props: any): any => config(props).media.md`
    font-size: 90px;
    line-height: 105%;
    margin-bottom: 1rem;
  `}
  ${(props: any): any => config(props).media.lg`
    text-align: left;
  `}
`
export const DescriptionText = styled(P)<any>`
  font-size: 16px;
  line-height: 1.5rem;
  margin: 0 0 20px;
  text-align: center;
  ${(props: any): any => config(props).media.sm`
    margin: 0 0 30px;
  `}
  ${(props: any): any => config(props).media.md`
    line-height: 1.95rem;
    white-space: pre-wrap;
  `}
  ${(props: any): any => config(props).media.lg`
    font-size: 18px;
    margin: 0 0 45px;
    text-align: left;
  `}
`
export const PaywallButton = styled.button<any>`
  font-family: 'Good Sans Bold';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 150%;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  background: ${colors.orange};
  border-radius: 100px;
  padding: 12px 40px;
  outline: none;
  border: none;
  color: ${colors.white};
  will-change: opacity;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
  ${(props: any): any => config(props).media.sm`
    margin: 0 0 32px;
    min-width: 255px;
    cursor: pointer;
    &:hover,
    &:focus {
      opacity: 0.5;
    }
  `}
  ${(props: any): any => config(props).media.lg`
    margin: 0 0 62px;
  `}
`
